import {
  CoverageTypesCodes,
  LOB,
  MemberCoverageTypeToUICoverageTypeConversion,
} from '../common/Constants';
import { GuestMemberInfo } from '../common/Portal/GuestPortalMemberInfo';

export const ConditionalObapiWrapper = ({ isUseOBAPI, wrapper, children }) =>
  isUseOBAPI ? wrapper(children) : children;

export const ConditionalPlanSelectorWrapper = ({
  isUsePlanSelector,
  wrapper,
  children,
}) => (isUsePlanSelector ? wrapper(children) : children);

export const ConditionalWrapper = ({ isCondition, wrapper, children }) =>
  isCondition ? wrapper(children) : children;

export const addDentalOrVisionNetworks = (guestPlans: GuestMemberInfo[]) => {
  const guestPlan = guestPlans?.at(0);
  if (!guestPlan || !guestPlan.eligibility?.length) return;
  if (guestPlan.lineOfBusiness === LOB.OBH) return;

  // Initialize networks as an empty array if not already present
  guestPlan.networks = guestPlan.networks || [];
  guestPlan.eligibility[0].memberHealthCoverage?.coverageType?.forEach(
    (coverage) => {
      if (
        coverage.typeCode.coverageTypeCode ===
        MemberCoverageTypeToUICoverageTypeConversion.D
      ) {
        guestPlan.networks.push({
          type: CoverageTypesCodes.DENTAL,
          value: [coverage.typeCode?.reciprocityId],
        });
      } else if (
        coverage.typeCode.coverageTypeCode ===
        MemberCoverageTypeToUICoverageTypeConversion.V
      ) {
        guestPlan.networks.push({
          type: CoverageTypesCodes.VISION,
          value: [coverage.typeCode?.reciprocityId],
        });
      }
    }
  );
};
